/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Req_1Inputs */

const en_pc_dl_req_1 = /** @type {(inputs: Pc_Dl_Req_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows (x64, ARM64 or 32-bit), macOS on Apple silicon or Intel, or FreeBSD.`)
};

const zh_pc_dl_req_1 = /** @type {(inputs: Pc_Dl_Req_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows（x64、ARM64 或 32 位）、Apple 芯片或 Intel 的 macOS，或 FreeBSD。`)
};

/**
* | output |
* | --- |
* | "Windows (x64, ARM64 or 32-bit), macOS on Apple silicon or Intel, or FreeBSD." |
*
* @param {Pc_Dl_Req_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_req_1 = /** @type {((inputs?: Pc_Dl_Req_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Req_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_req_1(inputs)
	return zh_pc_dl_req_1(inputs)
});
export { pc_dl_req_1 as "pc.dl.req.1" }